import { createAction } from '@reduxjs/toolkit';

export const confirmRegistration = createAction<string>('CONFIRM_REGISTRATION');
